import '@config';
import '@styles/login';

// Your code goes here ...

($ => {
  $(() => {
    $('[for="user_login"],[for="user_pass"],[for="user_email"]').each(
      (i, element) => {
        const input = document.querySelector(`#${element.getAttribute('for')}`);

        element.parentNode.classList.add('login__field-container');
        element.parentNode.classList.add(
          `login__field-container--${element.getAttribute('for')}`,
        );

        input.setAttribute('placeholder', element.innerText);
      },
    );
  });
})(jQuery);
